import Vue from 'vue'
import VueRouter from 'vue-router'
import Grid from '../views/Grid.vue'
import Document from '../views/Document.vue'
import LoginForm from '../views/account/LoginForm.vue'
import Unauthorized from '../views/Unauthorized.vue'

Vue.use(VueRouter)

function normalizeBaseUrl(value) {
    if (!value) return '/';

    let base = value;

    if (!base.startsWith('/')) {
        base = '/' + base;
    }

    if (!base.endsWith('/')) {
        base = base + '/';
    }

    return base;
}

const runtimeConfig = window.__DOCSAY_CONFIG__ || {};
const routerBaseUrl = normalizeBaseUrl(
    runtimeConfig.BASE_URL || process.env.VUE_APP_BASE_URL || '/'
);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Grid,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'LoginForm',
        component: LoginForm,
    },
    {
        path: '/document/:id',
        name: 'DocumentPage',
        component: Document,
        meta: { requiresAuth: true },
    },
    {
        path: '/unauthorized',
        name: 'Unauthorized',
        component: Unauthorized
    }
]

const router = new VueRouter({
    mode: 'history',
    base: routerBaseUrl,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        const loggedIn = localStorage.getItem('user');

        if (!loggedIn) {
            next({
                path: '/login',
                query: { redirect: to.fullPath },
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router